export default "__VITE_ASSET__NYIC7ZCV__"